import {DashboardCard} from '@/components/atoms'

/**
 * CardComponent renders a list of DashboardCard components.
 *
 * @param {Object[]} cardList - The list of card objects to be rendered.
 * @param {Object} cardList[].centralIcon - The central icon for the card.
 * @param {Object} cardList[].ctaPrimary - The primary call-to-action for the card.
 * @param {string} cardList[].title - The title of the card.
 *
 * @returns {JSX.Element} A fragment containing a list of DashboardCard components.
 */
const CardComponent = ({cardList}) => {
  return (
    <>
      {cardList?.map((card, i) => {
        const {centralIcon, ctaPrimary, title} = card || {}
        return <DashboardCard centralIcon={centralIcon} ctaPrimary={ctaPrimary} title={title} isDark key={i} />
      })}
    </>
  )
}

export default CardComponent
